const observe_videos = function() {
  const videoModules = document.querySelectorAll('.video-module');
  const rootStyles = getComputedStyle(document.documentElement);
  const fadeDuration = parseFloat(rootStyles.getPropertyValue('--dur')) * 1000; 

  videoModules.forEach(module => {
    const playButton = module.querySelector('.video-module__play-button');
    const video = module.querySelector('video');
    const poster = module.querySelector('.video-module__poster');

    if (playButton && video && poster) {
      playButton.addEventListener('click', () => {
        video.play();
        module.classList.add('active')
      });

      video.addEventListener('ended', () => {
        module.classList.remove('active')
      });
    }
    
    video.addEventListener('click', () => {
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    });
  });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        if (video.closest('.video-module').classList.contains('active')) {
            video.play();
        }
      } else {
        video.pause();
      }
    });
  });

  videoModules.forEach(module => {
    const video = module.querySelector('video');
    if (video) {
      observer.observe(video);
    }
  });
}


